import script from "./MainPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./MainPopup.vue?vue&type=script&setup=true&lang=js"

import "./MainPopup.vue?vue&type=style&index=0&id=60b4e7a8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60b4e7a8"]])

export default __exports__